import CredentialsContainer from "./CredentialsContainer";

export default CredentialsContainer;
